import MasterRoleAddForm from './MasterRoleAddForm';

export default MasterRoleAddForm;